var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75439 43.2337C8.92127 43.2337 11.5088 40.6217 11.5088 37.425V0H45.1086V37.425C45.1086 40.6217 42.521 43.2337 39.3542 43.2337",
    fill: "#00B074"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5998 37.4248V33.0195H0V37.4248C0 40.6215 2.58757 43.2334 5.75445 43.2334H39.3542C36.1873 43.2334 33.5998 40.6215 33.5998 37.4248Z",
    fill: "#0A5239"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8206 7.4458H17.5338V9.31705H21.8206V7.4458Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3115 7.4458H25.1419V9.31705H38.3115V7.4458Z",
    fill: "#F7C604"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8206 14.0732H17.5338V15.9445H21.8206V14.0732Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3115 14.0732H25.1419V15.9445H38.3115V14.0732Z",
    fill: "#F7C604"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8206 20.7007H17.5338V22.5719H21.8206V20.7007Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3115 20.7007H25.1419V22.5719H38.3115V20.7007Z",
    fill: "#F7C604"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8206 27.3281H17.5338V29.1994H21.8206V27.3281Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3115 27.3281H25.1419V29.1994H38.3115V27.3281Z",
    fill: "#F7C604"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.1086 27.64V5.37989C44.6452 5.30192 44.1431 5.26294 43.6411 5.26294C37.5004 5.26294 32.5184 10.2919 32.5184 16.4904C32.5184 22.689 37.5004 27.7179 43.6411 27.7179C44.1431 27.7569 44.6452 27.7179 45.1086 27.64Z",
    fill: "#0C1E5B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3762 24.5759C53.0245 24.5759 57.6035 19.9596 57.6035 14.265C57.6035 8.57045 53.0245 3.9541 47.3762 3.9541C41.7278 3.9541 37.1489 8.57045 37.1489 14.265C37.1489 19.9596 41.7278 24.5759 47.3762 24.5759Z",
    fill: "#FF5B5B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3078 18.2664C46.0025 18.2664 45.7354 18.151 45.5064 17.9201L42.2627 14.6499C41.8048 14.1882 41.8048 13.4572 42.2627 13.034C42.7206 12.5723 43.4457 12.5723 43.8655 13.034L46.3078 15.4963L50.8872 10.8795C51.3452 10.4178 52.0702 10.4178 52.49 10.8795C52.9479 11.3411 52.9479 12.0721 52.49 12.4954L47.1092 17.9201C46.8803 18.151 46.6131 18.2664 46.3078 18.2664Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview2);
export default __webpack_public_path__ + "static/media/overview-2.19f3904763315ba1dd44ec8b14d13a5f.svg";
export { ForwardRef as ReactComponent };